import { createMuiTheme } from "@material-ui/core/styles";
import { getDirection } from "../localization";

const darkPalette = {
  type: "dark",
  primary: { main: "#168BFF", contrastText: "#FFFFFF" },
  secondary: { main: "#94A3B8" },
  background: { default: "#060D18", paper: "#0B1424" },
  text: { primary: "#F8FAFC", secondary: "#94A3B8" },
};

const lightPalette = {
  type: "light",
  primary: { main: "#087FF5", contrastText: "#FFFFFF" },
  secondary: { main: "#5D6F86" },
  background: { default: "#F3F7FC", paper: "#FFFFFF" },
  text: { primary: "#10213B", secondary: "#5D6F86" },
};

export function createAppTheme(mode = "dark") {
  const direction = getDirection();
  const isLight = mode === "light";

  return createMuiTheme({
    direction,
    palette: isLight ? lightPalette : darkPalette,
    typography: {
      fontFamily:
        direction === "rtl"
          ? '"IRANSans", Tahoma, Arial, sans-serif'
          : '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
      h1: {
        fontWeight: 800,
        letterSpacing: direction === "rtl" ? 0 : "-0.035em",
      },
      h2: {
        fontWeight: 800,
        letterSpacing: direction === "rtl" ? 0 : "-0.025em",
      },
      h3: { fontWeight: 800 },
      h4: { fontWeight: 750 },
      button: {
        fontWeight: 700,
        textTransform: "none",
      },
    },
    shape: { borderRadius: 16 },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          body: {
            backgroundColor: isLight ? "#F3F7FC" : "#060D18",
            color: isLight ? "#10213B" : "#F8FAFC",
          },
        },
      },
      MuiButton: {
        root: { textTransform: "none" },
      },
      MuiIconButton: {
        root: {
          transition:
            "background-color .2s ease, color .2s ease, border-color .2s ease, transform .2s ease",
        },
      },
      MuiChip: {
        root: { maxWidth: "100%" },
        label: {
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      MuiDrawer: {
        paper: {
          transition: "background-color .25s ease, border-color .25s ease",
        },
      },
    },
  });
}

export default createAppTheme("dark");
